import {DataObject, Response, ResponseError} from "@/types";
import { ResponseStatus } from "@/constants/ajax";

export class ServerResponse implements Response {
  public readonly status: ResponseStatus;
  public readonly callback?: string;
  public readonly args?: object;
  public readonly token?: string;
  public readonly errors?: ResponseError[];
  public readonly dataContent?: DataObject;
  public readonly userId?: string;
  public readonly leadId?: string;
  public readonly restart?: boolean;
  public readonly next?: string;
  public readonly analytics?: { userId: string; leadId: string };

  constructor(response: any) {
    this.status = ResponseStatus.ERROR;

    Object.assign(this, response);
  }
}
